import * as Sentry from '@sentry/browser'
Sentry.init({
  dsn: 'https://d69259495e144410940fdc60c79a98aa@sentry.io/61281',
  environment: process.env.QA ? 'qa' : process.env.NODE_ENV
})
